import { PAUSE_MODAL } from "@/constants/campaignLifecycle";
import CampaignActionDialog from "./CampaignActionDialog";

interface PauseCampaignModalProps {
  open: boolean;
  campaignName: string;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirm pausing a LIVE campaign — the one pause that needs explaining (a scheduled/draft pause has
 * reached no recipient and happens silently, without this dialog). Plain subtitle, no callout box.
 */
export default function PauseCampaignModal({
  open,
  campaignName,
  onClose,
  onConfirm,
}: PauseCampaignModalProps) {
  return (
    <CampaignActionDialog
      open={open}
      title={PAUSE_MODAL.title(campaignName)}
      body={PAUSE_MODAL.body}
      primaryLabel={PAUSE_MODAL.confirm}
      secondaryLabel={PAUSE_MODAL.dismiss}
      onPrimary={onConfirm}
      onClose={onClose}
    />
  );
}
